import { render, staticRenderFns } from "./customDashboardSvgs.vue?vue&type=template&id=721c099a"
import script from "./customDashboardSvgs.vue?vue&type=script&lang=js"
export * from "./customDashboardSvgs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports